import { render, staticRenderFns } from "./referrer-details-header.vue?vue&type=template&id=3ed031e4"
import script from "./referrer-details-header.vue?vue&type=script&lang=js"
export * from "./referrer-details-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports